<template lang="pug">
  .sichuan-flow
    .header
      img(src="@/assets/images/sichuan/header-bg.png")
    .main
      .form 恭喜您，办理成功！
</template>

<script>
export default {
  name: 'SiChuanFlowSuccess',
  methods: {
  }
}
</script>

<style lang="less" scoped>
.sichuan-flow{
  background: rgb(5, 19, 30);
  padding-bottom: 10rem;
}
.header{
  img{
    width: 100%;
  }
}
.main{
  width: 90%;
  margin: 0 auto;
}
.form{
  color: #10d4db;
  text-align: center;
  font-size: 1.2rem;
}
</style>